/* eslint-disable react/jsx-filename-extension */
import React from 'react';
import PaginasEspecificas from '../../../../components/paginasEspecificas';

function Movimento() {
  return (
    <PaginasEspecificas posicao="13" endereco="/fisica" materia="Física" />
  );
}

export default Movimento;
